const FundingFilters = [
    {
      heading: 'Academic & Research Context',
      fields: [
        {
          key: 'specialty',
          label: 'Specialty',
          type: 'input',
          placeholder: 'Specify your specialty',
        },
        {
          key: 'sub_specialty',
          label: 'Sub-specialty',
          type: 'input',
          placeholder: 'Specify your sub-specialty',
        },
        {
          key: 'degree_type',
          label: 'Degree Type',
          type: 'select',
          options: ['Master’s', 'PhD', 'Postdoc', 'MD/PhD', 'Other'],
        },
        {
          key: 'year_in_program',
          label: 'Year in Program',
          type: 'select',
          options: ['1', '2', '3', '4+'],
        },
        {
          key: 'stage_of_research',
          label: 'Stage of Research',
          type: 'select',
          options: ['Proposal', 'Data Collection', 'Analysis', 'Dissemination'],
        },
        {
          key: 'publication_record',
          label: 'Publication Record',
          type: 'select',
          options: ['None', '<3 publications', '≥3 publications'],
        },
        {
          key: 'patent_status',
          label: 'Patent/Innovation Status',
          type: 'select',
          options: ['None', 'Pending', 'Filed', 'Granted'],
        },
      ],
    },
    {
      heading: 'Funding Eligibility Criteria',
      fields: [
        {
          key: 'career_stage',
          label: 'Career Stage',
          type: 'select',
          options: ['Early Career', 'Mid-career', 'Transitioning Fields'],
        },
        {
          key: 'employment_status',
          label: 'Employment Status',
          type: 'select',
          options: ['Full-time student', 'Part-time', 'Adjunct', 'Unemployed', 'Employed'],
        },
        {
          key: 'grant_size_preference',
          label: 'Grant Size Preference',
          type: 'select',
          options: ['<$5k', '$5k–$50k', '>$50k', 'All'],
        },
        {
          key: 'desired_duration',
          label: 'Desired duration of funding',
          type: 'select',
          options: ['One-time', '1-2 years', '3 years or longer', 'All'],
        },
        {
          key: 'funding_source_type',
          label: 'Funding Source Type',
          type: 'select',
          multiple: true,
          options: ['Government', 'Philanthropic', 'Corporate', 'University', 'All'],
        },
      ],
    },
    {
      heading: 'Geographic & Mobility Factors',
      fields: [
        { key: 'university_affiliation', label: 'University Affiliation', type: 'input' },
        { key: 'lab_affiliation', label: 'Lab Affiliation', type: 'input' },
        { key: 'country_of_citizenship', label: 'Country of Citizenship', type: 'input' },
        { key: 'country_of_residence', label: 'Country of Residence', type: 'input' },
        { key: 'region_state', label: 'Region/State', type: 'input' },
        {
          key: 'willing_to_relocate',
          label: 'Willing to Relocate',
          type: 'select',
          multiple: true,
          options: ['Yes', 'No', 'Short-term only', 'All'],
        },
        {
          key: 'travel_for_research',
          label: 'Travel for Research',
          type: 'select',
          multiple: true,
          options: ['Local', 'National', 'International', 'All'],
        },
      ],
    },
    {
      heading: 'Equity & Inclusion-Linked Eligibility',
      fields: [
        {
          key: 'gender',
          label: 'Gender',
          type: 'select',
          options: ['Male', 'Female', 'Decline'],
        },
        {
          key: 'lgbtqai_affiliation',
          label: 'LGBTQAI+ Affiliation',
          type: 'select',
          options: ['Yes', 'No', 'Decline'],
        },
        {
          key: 'first_gen_college',
          label: 'First-Generation College Student',
          type: 'select',
          options: ['Yes', 'No', 'Decline'],
        },
        {
          key: 'disability_status',
          label: 'Disability Status',
          type: 'select',
          options: ['Yes', 'No', 'Decline'],
        },
        {
          key: 'underrepresented_minority',
          label: 'Underrepresented Minority in Field',
          type: 'select',
          options: ['Yes', 'No', 'Decline'],
        },
        {
          key: 'veteran_status',
          label: 'Veteran Status',
          type: 'select',
          options: ['Yes', 'No', 'Decline'],
        },
      ],
    },
    {
      heading: 'Research Characteristics',
      fields: [
        {
          key: 'research_type',
          label: 'Research Type',
          type: 'select',
          options: ['Basic', 'Applied', 'Translational', 'Policy-Oriented'],
        },
        {
          key: 'methodology',
          label: 'Methodology',
          type: 'select',
          options: ['Quantitative', 'Qualitative', 'Mixed', 'Experimental', 'Computational'],
        },
        {
          key: 'interdisciplinary',
          label: 'Interdisciplinary Component',
          type: 'select',
          options: ['Yes', 'No'],
        },
        {
          key: 'sdg_impact_area',
          label: 'SDG/Impact Area',
          type: 'input',
          placeholder: '',
        },
      ],
    },
    {
      heading: 'Administrative & Logistical',
      fields: [
        {
          key: 'application_deadline',
          label: 'Application Deadline',
          type: 'select',
          options: ['≤30 days', '≤3 months', '≤6 months'],
        },
        {
          key: 'funding_recurrence',
          label: 'Funding Recurrence',
          type: 'select',
          options: ['One-time', 'Renewable'],
        },
        {
          key: 'institutional_match_required',
          label: 'Institutional Match Required',
          type: 'select',
          options: ['Yes', 'No'],
        },
        {
          key: 'languages_fluent',
          label: 'Language(s) in which fluent',
          type: 'input',
          placeholder: '',
        },
      ],
    },
    {
      heading: 'Other',
      fields: [
        {
          key: 'free_text_search',
          label: 'Free Text Search (up to 100 characters)',
          type: 'input',
          maxlength: 100,
          placeholder: '',
        },
      ],
    },
  ];
export default FundingFilters;